/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontContactModal_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontAboutSection_seller$ref: FragmentReference;
export type StorefrontAboutSection_seller = {|
  +storefrontProfile: ?{|
    +aboutUs: ?string,
    +logo: ?{|
      +path: ?string
    |},
  |},
  +sellerProfile: ?{|
    +company: ?string
  |},
  +sellerPreferences: ?{|
    +scrollLogoLg: ?string,
    +displayStoreAddress: ?any,
    +storeAddressByAppointmentOnly: ?any,
  |},
  +tradeAssociations: ?$ReadOnlyArray<?{|
    +displayName: ?string
  |}>,
  +$fragmentRefs: StorefrontContactModal_seller$ref,
  +$refType: StorefrontAboutSection_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontAboutSection_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "storefrontId",
      "type": "Int"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontContactModal_seller",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storefrontProfile",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storefrontId",
          "variableName": "storefrontId",
          "type": "Int"
        }
      ],
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "aboutUs",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "logo",
          "storageKey": null,
          "args": null,
          "concreteType": "Photo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerPreferences",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrollLogoLg",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayStoreAddress",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "storeAddressByAppointmentOnly",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeAssociations",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '38bb5cad47d13d5d2d27ab20fe35b7ec';
module.exports = node;
